"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = extractBoundariesFromSrc;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Extracts the start and end time from the url based on specific keys:
 *   startOffsetMs {number}
 *   durationMs {number}
 *
 * @deprecated This will be moved into the VPE
 * @param {string} src
 * @return {{startTime: number, endTime: number|undefined}}
 */
function extractBoundariesFromSrc(src) {
  var output = {
    startTime: undefined,
    endTime: undefined
  };
  var offsetAnchorMatches = src.match(/#startOffsetMs=[0-9]*&durationMs=[0-9]*$/);
  if (offsetAnchorMatches) {
    var _offsetAnchorMatches = _slicedToArray(offsetAnchorMatches, 1),
      anchorText = _offsetAnchorMatches[0];
    var parsedStartTime = parseInt(anchorText.match(/startOffsetMs=[0-9]*/)[0].replace('startOffsetMs=', ''), 10) / 1000;
    var parsedEndTime = parsedStartTime + parseInt(anchorText.match(/durationMs=[0-9]*/)[0].replace('durationMs=', ''), 10) / 1000;
    output.startTime = parsedStartTime;
    output.endTime = parsedEndTime;
  }
  return output;
}